import DocumentoVersaoInteressado from "../DocumentoVersaoInteressado";
import DocumentoVersaoNecessidadeConfirmacao from "../DocumentoVersaoNecessidadeConfirmacao";

export default class PublicarVersao {
    idVersao: number;
    codigo = "";
    diasConfirmacaoLeitura: number | null;
    validade: Date | null = null;
    interessados: DocumentoVersaoInteressado[];
    necessidadesConfirmacao: DocumentoVersaoNecessidadeConfirmacao[];

    constructor(
        idVersao: number = 0,
        diasConfirmacaoLeitura = 0,
        validade: Date | null = null,
        interessados = [],
        necessidadesConfirmacao = []
    ) {
        this.idVersao = idVersao;
        this.diasConfirmacaoLeitura = diasConfirmacaoLeitura;
        this.validade = validade;
        this.interessados = interessados;
        this.necessidadesConfirmacao = necessidadesConfirmacao;
    }
}